/**
 * DO NOT EDIT THIS FILE DIRECTLY
 * This file generated by web-components/build/generate-default-palettes.js
 */
export const neutralPalette = [
    "#FFFFFF",
    "#FCFCFC",
    "#FAFAFA",
    "#F7F7F7",
    "#F5F5F5",
    "#F2F2F2",
    "#EFEFEF",
    "#EDEDED",
    "#EAEAEA",
    "#E8E8E8",
    "#E5E5E5",
    "#E2E2E2",
    "#E0E0E0",
    "#DDDDDD",
    "#DBDBDB",
    "#D8D8D8",
    "#D6D6D6",
    "#D3D3D3",
    "#D0D0D0",
    "#CECECE",
    "#CBCBCB",
    "#C9C9C9",
    "#C6C6C6",
    "#C3C3C3",
    "#C1C1C1",
    "#BEBEBE",
    "#BCBCBC",
    "#B9B9B9",
    "#B6B6B6",
    "#B4B4B4",
    "#B1B1B1",
    "#AFAFAF",
    "#ACACAC",
    "#A9A9A9",
    "#A7A7A7",
    "#A4A4A4",
    "#A2A2A2",
    "#9F9F9F",
    "#9D9D9D",
    "#9A9A9A",
    "#979797",
    "#959595",
    "#929292",
    "#909090",
    "#8D8D8D",
    "#8A8A8A",
    "#888888",
    "#858585",
    "#838383",
    "#808080",
    "#7D7D7D",
    "#7B7B7B",
    "#787878",
    "#767676",
    "#737373",
    "#717171",
    "#6E6E6E",
    "#6B6B6B",
    "#696969",
    "#666666",
    "#646464",
    "#616161",
    "#5F5F5F",
    "#5C5C5C",
    "#5A5A5A",
    "#575757",
    "#545454",
    "#525252",
    "#4F4F4F",
    "#4D4D4D",
    "#4A4A4A",
    "#484848",
    "#454545",
    "#424242",
    "#404040",
    "#3D3D3D",
    "#3B3B3B",
    "#383838",
    "#363636",
    "#333333",
    "#313131",
    "#2E2E2E",
    "#2B2B2B",
    "#292929",
    "#262626",
    "#242424",
    "#212121",
    "#1E1E1E",
    "#1B1B1B",
    "#181818",
    "#151515",
    "#121212",
    "#101010",
    "#000000"
];
export const accentPalette = [
    "#FFFFFF",
    "#FBFDFE",
    "#F6FAFE",
    "#F2F8FD",
    "#EEF6FC",
    "#E9F4FB",
    "#E5F1FB",
    "#E1EFFA",
    "#DCEDF9",
    "#D8EAF8",
    "#D4E8F8",
    "#CFE6F7",
    "#CBE4F6",
    "#C7E1F6",
    "#C2DFF5",
    "#BEDDF4",
    "#BADAF3",
    "#B6D8F3",
    "#B1D6F2",
    "#ADD4F1",
    "#A9D1F0",
    "#A4CFF0",
    "#A0CDEF",
    "#9CCAEE",
    "#97C8EE",
    "#93C6ED",
    "#8FC4EC",
    "#8AC1EB",
    "#86BFEB",
    "#82BDEA",
    "#7DBAE9",
    "#79B8E8",
    "#75B6E8",
    "#70B3E7",
    "#6CB1E6",
    "#68AFE5",
    "#63ADE5",
    "#5FAAE4",
    "#5BA8E3",
    "#56A6E3",
    "#52A3E2",
    "#4EA1E1",
    "#499FE0",
    "#459DE0",
    "#419ADF",
    "#3D98DE",
    "#3896DD",
    "#3493DD",
    "#3091DC",
    "#2B8FDB",
    "#278DDB",
    "#238ADA",
    "#1E88D9",
    "#1A86D8",
    "#1683D8",
    "#1181D7",
    "#0D7FD6",
    "#097DD5",
    "#047AD5",
    "#0078D4",
    "#0075CF",
    "#0072C9",
    "#006FC4",
    "#006CBE",
    "#0069B9",
    "#0066B4",
    "#0063AE",
    "#0060A9",
    "#005CA3",
    "#00599E",
    "#005699",
    "#005393",
    "#00508E",
    "#004D88",
    "#004A83",
    "#00477D",
    "#004478",
    "#004173",
    "#003E6D",
    "#003B68",
    "#003862",
    "#00355D",
    "#003258",
    "#002F52",
    "#002B4D",
    "#002847",
    "#002542",
    "#00223C",
    "#001F36",
    "#001B30",
    "#00182B",
    "#001525",
    "#00121F",
    "#000000"
];
